import { Shimmer } from '@fluentui/react';
import { SearchFilterFrame } from './SearchDetailsList/SearchFilter/SearchFilterFrame';
import { SearchFilterShimmer } from './SearchDetailsList/SearchFilter/SearchFilterShimmer';
import { useThemeData } from '@msrceng/theme';
import { getSearchListStyle } from './SearchDetailsList/getSearchListStyle';
import { LightDetailsListShimmer } from 'component/LightDetailsListShimmer/LightDetailsListShimmer';

/**
 * This is a shimmer to render in place of a `SearchDetailsList` while it is loading.
 */
export const SearchDetailsListShimmer = ({
  filterCount = 5,
  columns = [],
  tableName = 'shimmer',
}: ISearchDetailsListShimmerProps) => {
  const { theme } = useThemeData() || {};
  return (
    <div style={getSearchListStyle(theme)} aria-label={tableName}>
      <Shimmer styles={{ root: { height: '43px', padding: 10 } }} />
      <SearchFilterFrame visible>
        <SearchFilterShimmer length={filterCount} />
      </SearchFilterFrame>
      <LightDetailsListShimmer {...{ columns }} />
    </div>
  );
};

export interface ISearchDetailsListShimmerProps {
  /** Optionally provide the number of controls to render in "filters" bar. */
  filterCount?: number;
  /** Optionally provide the columns to render in the list. */
  columns?: any[];
  /** The name of the table */
  tableName: string;
}
